// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2wXQF","resendInfoText":"OnGoingPaymentBox_resendInfoText__22o19"};